import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { AGGREGATED_TRIPS_AUGUST_H3_GRADIENT_LEGEND } from '../../../constants/legends';
import styles from '../FilterSidebar.module.css';

const H3_ZOOMS = [ 6, 7, 8, 9, 10, 11, 12, 'auto' ];
const AggTripsH3FilterComponent = ({
    onChangeMapFilters,
    aggTracksAugustH3Zoom,
}) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('aggTracksAugustH3Zoom', value);
    };
    const toggleH3Zoom = () => {
        setIsH3ZoomExpanded(!isH3ZoomExpanded);
    };

    return (
        <div>
            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(aggTracksAugustH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {
                        H3_ZOOMS.map(zoom => (
                            <FormControlLabel
                                key={zoom}
                                className={styles.isochroneFilterLabel}
                                control={
                                    <Radio
                                        checked={String(aggTracksAugustH3Zoom) === String(zoom)}
                                        onChange={handleH3ZoomChange}
                                        value={String(zoom)}
                                        className={classnames(
                                            styles.isochroneFilterInput, {
                                                [styles.checkedIsochroneFilterInput]: String(aggTracksAugustH3Zoom) === String(zoom),
                                            }
                                        )}
                                        size="small"
                                    />
                                }
                                label={zoom}
                            />
                        ))
                    }
                </StandardRadioGroup>
            )}

            <LegendRenderer config={AGGREGATED_TRIPS_AUGUST_H3_GRADIENT_LEGEND} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { aggTracksAugustH3Zoom } }) => ({
    aggTracksAugustH3Zoom,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(AggTripsH3FilterComponent);

export const AggTripsAugustH3Filter = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Агрегированные поездки (август)`
);
